import { useState } from "react";
import {
  Image as ImageIcon,
  Download,
  X,
} from "lucide-react";

export default function ImageGallery({ images = [] }) {
  const [selectedImage, setSelectedImage] = useState(null);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  if (!images.length) {
    return (
      <div className="rounded-[30px] border border-slate-200 bg-white p-12 text-center shadow-sm">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-slate-100">
          <ImageIcon className="text-slate-400" size={36} />
        </div>

        <h2 className="mt-6 text-2xl font-bold text-slate-900">
          No Images Found
        </h2>

        <p className="mt-2 text-slate-500">
          No prescription images have been uploaded.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-sm">

        {/* Header */}
        <div className="bg-gradient-to-r from-slate-900 to-slate-800 px-8 py-6">

          <div className="flex items-center justify-between">

            <div>

              <h2 className="text-2xl font-bold text-white">
                Prescription Images
              </h2>

              <p className="mt-1 text-slate-300">
                Total Images : {images.length}
              </p>

            </div>

          </div>

        </div>

        {/* Gallery */}
        <div className="grid grid-cols-1 gap-6 p-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

          {images.map((image) => {
            const imageUrl = `${API_URL}/api/uploads/customers/${image.image}`;
            return (
              <div
                key={image.id}
                className="overflow-hidden rounded-2xl border border-slate-200 bg-white transition duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <div
                  className="cursor-pointer overflow-hidden"
                  onClick={() => setSelectedImage(imageUrl)}
                >
                  <img
                    src={imageUrl}
                    alt={image.original_name}
                    className="h-60 w-full object-cover transition duration-500 hover:scale-110"
                  />
                </div>

                <div className="space-y-2 p-4">

                  <h3 className="truncate font-semibold text-slate-900">
                    {image.original_name}
                  </h3>

                  <p className="text-sm text-slate-500">
                    {(image.image_size / 1024).toFixed(1)} KB
                  </p>

                  <p className="text-xs uppercase text-slate-400">
                    {image.image_type}
                  </p>

                  <button
  onClick={async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = image.original_name || image.image;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
    }
  }}
  className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
>
  <Download size={18} />
  Download
</button>

                </div>
              </div>
            );
          })}

        </div>

      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/90 p-6">

          <button
            onClick={() => setSelectedImage(null)}
            className="absolute right-6 top-6 rounded-full bg-white p-2"
          >
            <X size={22} />
          </button>

          <img
            src={selectedImage}
            alt="Preview"
            className="max-h-[90vh] max-w-[95vw] rounded-2xl shadow-2xl"
          />

        </div>
      )}
    </>
  );
}